<p-card>
    <div class="w-count-box" [style.background-color]="widget().WidgetData.backgroundcolor">{{widget().Title}}</div>
    <div class="w-count-box" [style.background-color]="widget().WidgetData.backgroundcolor" [innerHtml]="widget().WidgetData.count"></div>
</p-card>

